import { render, staticRenderFns } from "./dfhOrder.vue?vue&type=template&id=05cb9ce2&scoped=true"
import script from "./dfhOrder.vue?vue&type=script&lang=js"
export * from "./dfhOrder.vue?vue&type=script&lang=js"
import style0 from "./dfhOrder.vue?vue&type=style&index=0&id=05cb9ce2&prod&lang=css"
import style1 from "./dfhOrder.vue?vue&type=style&index=1&id=05cb9ce2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cb9ce2",
  null
  
)

export default component.exports